import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

const HtmlInput = ({
  type = 'text',
  id,
  name,
  legend,
  value,
  hasErrors = false,
  inputRef = useRef(null),
  detectCapsLock = false,
  changeCallback = () => {},
  mouseDownCallback = () => {},
  blurCallback = () => {},
  onKeydownCallback = () => {},
  onKeyupCallback = () => {},
  onFocusCallback = () => {},
}) => {
  const {t:translate} = useTranslation();
  const [isFocused, setIsFocused] = useState(false);
  const [capsLockOn, setCapsLockOn] = useState(false);

  const handleChange = (e) => {
    const { value } = e.target;

    if (value !== '') {
      setIsFocused(true);
    } else {
      setIsFocused(false);
    }
  };

  const handleBlur = (e) => {
    const { value } = e.target;
    if (value !== '') {
      setIsFocused(true);
    } else {
      setIsFocused(false);
    }
  };

  const checkForCaps = (event) => {
    let isCapsLockOn = event.getModifierState("CapsLock");
    if(isCapsLockOn) {
        setCapsLockOn(true);
    } else {
        setCapsLockOn(false);
    }
  }

  // eslint-disable-next-line
  const onAnimationStart = ({ target, animationName }) => {
    if (animationName === 'onAutoFillStart') {
      setIsFocused(true);
    } else {
      setIsFocused(false);
    }
  };

  useEffect(() => {
    //Little hack to check for autofill values
    //Using psuedo class :-webkit-autofill we add an animation
    //We then check for this animation starting
    //We check if animation name is our start animation and update the focused state if it is
    document
      .getElementById(id)
      .addEventListener('animationstart', onAnimationStart, false);

    if (value) {
      setIsFocused(true);
    }
  }, []);

  useEffect(() => {
    if( value ) {
      setIsFocused(true);
    }
  }, [value])

  return (
    <div
      className={`gl-input ${isFocused ? 'gl-input--isFocused' : ''} ${
        hasErrors ? 'gl-input--errors' : ''
      } ${capsLockOn ? 'gl-input--hasCaps' : ''}`}
    >
      <label htmlFor={name}>{legend}</label>
      <div className="gl-input__container">
        <input
          type={type}
          id={id}
          name={name}
          onFocus={(e) => {setIsFocused(true); onFocusCallback(e);}}
          onMouseDown={(e) => {
            mouseDownCallback(e);
          }}
          onBlur={(e) => {
            handleBlur(e);
            blurCallback(e);
            setCapsLockOn(false);
          }}
          onChange={(e) => {
            changeCallback(e);
            handleChange(e);
          }}
          onKeyDown={(e) => {
            onKeydownCallback(e);
            if( detectCapsLock === true ) {
              checkForCaps(e);
            }
          }}
          onKeyUp={(e) => {
            onKeyupCallback(e);
            if( detectCapsLock === true ) {
              checkForCaps(e);
            }
          }}
          ref={inputRef}
          value={value}
        />
        <fieldset>
          <legend>
            <span>{legend}</span>
          </legend>
        </fieldset>
        {capsLockOn && <span className='gl-input__caps-detector'>{translate('caps-lock-on')}</span>}
      </div>
    </div>
  );
};

export default HtmlInput;
